import { render } from "./AppSalaryMass.vue?vue&type=template&id=883a6ebc&scoped=true"
import script from "./AppSalaryMass.vue?vue&type=script&lang=js"
export * from "./AppSalaryMass.vue?vue&type=script&lang=js"

import "./AppSalaryMass.vue?vue&type=style&index=0&id=883a6ebc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-883a6ebc"]])

export default __exports__